import { Locale } from 'modules/i18n';

export const bundleProgressBarTranslation = {
  [Locale.en]: {
    expire: 'Expire: {date, date, long}',
    renew: 'Renew: {date, date, long}',
  },
};
